import { useQueries, useQuery } from "@tanstack/react-query";
import { publicServerEndpoint } from "../../services/helper";
import { ALL_PRODUCTS_OBJECT } from "./CollectionHome";

export const useCollectionsQuery = (storeId) => {
  return useQuery({
    queryKey: ["collections", storeId],
    queryFn: async () => {
      const url = `${publicServerEndpoint}/v3/collection/store/${storeId}?limit=5`;
      const response = await fetch(url);
      let collections = await response.json();
      if (collections && collections.collections.length === 0) {
        collections.push(ALL_PRODUCTS_OBJECT);
      }

      return collections.collections;
    },
    enabled: !!storeId,
  });
};

export const useCollectionWithStoreProducts = (storeId) => {
  const { data: collections } = useCollectionsQuery(storeId);
  const safeCollections = collections || [];

  const productQueries = useQueries({
    queries: safeCollections?.map((collection) => ({
      queryKey: ["collectionProducts", storeId, collection._id],
      queryFn: async () => {
        const idParam = collection._id === "all" ? "" : collection._id;
        const url = `${publicServerEndpoint}/v3/product/store/${storeId}/collectionv2?page=1&limit=10&source=web&collectionId=${idParam}`;
        const response = await fetch(url);
        const data = await response.json();
        return data.data?.docs || [];
      },
      enabled: !!storeId,
    })),
  });

  const combinedCollections = safeCollections.map((collection, index) => ({
    collection,
    products: productQueries[index]?.data || [],
    isLoading: productQueries[index]?.isLoading,
  }));

  return {
    data: combinedCollections,
    loading: productQueries.some((query) => query.isLoading),
  };
};
